export const CoreDataSecurityMonitorsAllName = 'CoreDataSecurityMonitorsAll';
